










































import { Vue, Component } from 'vue-property-decorator'
import { mapGetters, mapState } from 'vuex'
import { liste_videos } from '@/types/Tutoriel'

@Component({
    computed: {
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA']),
        ...mapState('auth', ['user', 'authUser'])
    }
})
export default class Aide extends Vue {
    videos = liste_videos
    video_select: any = null
    server_base_url = process.env.VUE_APP_API_URL

    // Sélection d'une video
    selectVideo (video: any) {
        this.video_select = video
        for (const v in this.videos) {
            this.videos[v].select = false
        }
        this.video_select.select = true
    }

    beforeMount () {
        this.selectVideo(this.videos[0])
    }
}
